import {
    NinchatActionType,
    NinchatUpdateSessionAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateSession = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateSessionAction}`,
    (arg: NinchatActionParams<NinchatUpdateSessionAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateSessionAction

        try {
            ninchatClient.send(params)
            return params
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
